<script async data-lazy lang="ts">
    import s from './style.module.css';
    import {onDestroy, onMount} from 'svelte';

    export let isLoadChat;
    export let GUSA_ADA_OPTIONS: typeof window.adaSettings;

    /**
     * exit ada options
     * for base used spread gusa options
     * parentElement - for HTMLElement where chat will be rendered
     * greeting - campaign id from gusa.ada.support/answers block (need to execute campaign without triggerCampaign fn)
     */
    const EXIT_ADA_OPTIONS: typeof window.adaSettings = {
        ...GUSA_ADA_OPTIONS,
        parentElement: 'adaChatContainer',
        greeting: '6478766424c33c3b8e2f6603',
    };

    /**
     * on mount start ada exit scenario
     * important to adaEmbed.stop() current chat to prevent chatter conflict
     */
    onMount(() => {
        window.adaEmbed.start(EXIT_ADA_OPTIONS);
        isLoadChat = true;
    });
    /**
     * on unmount start ada gusa scenario
     * it deletes exit scenario necessary fields etc. parent and greetings
     */
    onDestroy(() => {
        window.adaEmbed.stop();
        delete window.adaSettings.parentElement;
        delete window.adaSettings.greeting;
        window.adaEmbed.start(GUSA_ADA_OPTIONS);
        window.adaEmbed.reset();
    });
</script>

<div class={s.chatWrapper}>
    <div id="adaChatContainer" class={s.main} />
</div>
